import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaTwitter,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-section">
      {/* Top Section: Newsletter / Subscription */}
      {/* <div className="footer-newsletter py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <h3 className="font-serif text-white mb-2">
                Connect with the Divine
              </h3>
              <p className="text-white-50 mb-0">
                Subscribe to get latest updates on katha schedules and spiritual
                quotes.
              </p>
            </Col>
            <Col lg={6}>
              <Form className="d-flex gap-2">
                <Form.Control
                  type="email"
                  placeholder="Your Email Address"
                  className="rounded-0 border-0 py-3 px-4 shadow-none"
                />
                <Button className="btn-gold rounded-0 px-4 fw-bold">
                  SUBSCRIBE
                </Button>
              </Form>
            </Col>
          </Row>
        </Container>
      </div> */}

      {/* Main Footer Links */}
      <div className="footer-main py-5">
        <Container>
          <Row className="gy-5">
            {/* Column 1: Brand Bio */}
            <Col lg={4} md={6}>
              <div className="footer-logo mb-4">
                <h2 className="font-serif text-warning m-0">VISHNU JI</h2>
                <span className="text-uppercase tracking-widest text-white-50 small">
                  Maharaj Official
                </span>
              </div>
              <p className="footer-about pe-lg-4">
                Dedicated to spreading the message of peace, love, and spiritual
                wisdom across the globe. Join us in our mission of human service
                and enlightenment.
              </p>
              <div className="social-links d-flex gap-3 mt-4">
                <a
                  href="https://www.facebook.com/Bhaktivedmala/"
                  className="social-icon"
                  target="_blank"
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://www.instagram.com/bhaktivedmala/"
                  className="social-icon"
                  target="_blank"
                >
                  <FaInstagram />
                </a>

                <a
                  href="https://www.youtube.com/@bhaktivedmala"
                  className="social-icon"
                  target="_blank"
                >
                  <FaYoutube />
                </a>
              </div>
            </Col>

            {/* Column 2: Quick Links */}
            <Col lg={2} md={6}>
              <h5 className="footer-heading mb-4">Explore</h5>
              <ul className="footer-links list-unstyled">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/katha/">Hindi Katha Books</Link>
                </li>
                <li>
                  <Link to="/blogs">Blogs</Link>
                </li>
                <li>
                  <Link to="/video">Videos</Link>
                </li>
                {/* <li>
                  <Link to="/gallery">Darshan Gallery</Link>
                </li> */}
                <li>
                  <Link to="/contact">Contact Us</Link>
                </li>
              </ul>
            </Col>

            {/* Column 3: Important Sections */}
            <Col lg={2} md={6}>
              <h5 className="footer-heading mb-4">Services</h5>
              {/* <ul className="footer-links list-unstyled">
                <li>
                  <a href="#">Gau Sewa</a>
                </li>
                <li>
                  <a href="#">Anna Daan</a>
                </li>
                <li>
                  <a href="#">Bal Sanskaar</a>
                </li>
                <li>
                  <a href="#">Upcoming Events</a>
                </li>
                <li>
                  <a href="#">Donations</a>
                </li>
              </ul> */}
            </Col>

            {/* Column 4: Contact Info */}
            <Col lg={4} md={6}>
              <h5 className="footer-heading mb-4">Contact Office</h5>
              <div className="contact-info">
                <div className="d-flex gap-3 mb-3">
                  <FaMapMarkerAlt className="text-warning mt-1" />
                  <p className="mb-0">
                    Shree Vishnu Dham Ashram, <br /> Mathura, Vrindavan - 249401
                  </p>
                </div>
                {/* <div className="d-flex gap-3 mb-3">
                  <FaPhoneAlt className="text-warning mt-1" />
                  <p className="mb-0">+91 98765 43210</p>
                </div> */}
                <div className="d-flex gap-3">
                  <FaEnvelope className="text-warning mt-1" />
                  <p className="mb-0">info@vishnujimaharaj.com</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Bottom Copyright Bar */}
      <div className="footer-bottom py-4">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="text-center text-md-start mb-3 mb-md-0">
              <p>
                {" "}
                &copy; 2026{" "}
                <a
                  href="https://www.vishnujimaharaj.com/"
                  className="mb-0 text-white-50  text-warning fw-bold"
                >
                  <b className="text-warning">Vishnu Ji Maharaj</b>
                </a>{" "}
                Official. All Rights Reserved.
              </p>
            </Col>
            <Col md={6} className="text-center text-md-end">
              <p className="mb-0 text-white-50 small">
                Designed & Managed by{" "}
                <span className="text-warning fw-bold">Shree Cyber World</span>
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
